import FAQArticlePage from "./FAQArticle";

const data = {
  title: "Where is my refund?",
  category: "Billing & Payments",
  content: `Refunds typically take 14 business days to appear in your account after processing.

Refund timeline:
- Day 0: Refund is processed and approved by our team
- Day 1-3: Refund is submitted to your payment provider
- Day 3-14: Your bank or card issuer processes the refund

Why does it take time?
- Different banks and payment methods have varying processing times
- Credit card refunds may take longer than debit card refunds
- International transactions may require additional processing time

What to do if your refund is delayed:
1. Check your original payment method statement carefully
2. Look for refunds under the same merchant name as the original charge
3. If 14 business days have passed and you still haven't received your refund, please contact our support team with your transaction details

When contacting us about a delayed refund, please provide:
- Your full name
- The email address used for the subscription
- The transaction date and amount
- The last 4 digits of the card used (if applicable)

Email: support@novavertextech.com
Phone: +44 7520 663474`,
};

export default function BPQ1Page() {
  return <FAQArticlePage data={data} />;
}